import React, { FC } from 'react';
import RulesContainer from './rulesContainer/RulesContainer';
import CancellationRulesCard from './cancellationRulesCard/CancellationRulesCard';
import UnConditionalTransfer from './unConditionalTransfer/UnConditionalTransfer';
import Box from '@/components/UI/box/Box';
import Modal from '@/components/UI/modal/Modal';
import Drawer from '@/components/UI/drawer/Drawer';
import useDevice from '@/hooks/useDevice';
import useDrawer from '@/hooks/useDrawer';
import Divider from '@/components/UI/divider/Divider';
import Typography from '@/components/UI/typography/Typography';
import { useMidTermQuery } from '@/components/houses/_hooks/useMidterm';
import { cancellationPlans, cancellationTranslate } from './_constants/rulesConstants';
import { ProductItemTypes } from '@/components/houses/_types/productItem.types';
import styles from './Rules.module.scss';
import CancellationRulesContainer from '@/components/houses/_reusable/houseInfo/rules/cancellationRulesContainer/CancellationRulesContainer';
type RulesProps = {
  props: ProductItemTypes;
};
const Rules: FC<RulesProps> = ({
  props
}) => {
  const data = props?.rules?.records;
  const cancellationPlan = cancellationTranslate[cancellationPlans[data?.cancellation_plan]];
  const {
    isMidTerm
  } = useMidTermQuery(props);
  const {
    drawerOpen,
    drawerClose,
    isDrawerOpen
  } = useDrawer();
  const {
    isMobile
  } = useDevice();
  return <Box className={styles['rules-content']} id="rules" component={'section'} data-sentry-element="Box" data-sentry-component="Rules" data-sentry-source-file="Rules.tsx">
      <Typography variant="bodyL_Bold" color="neutral_800" component="h2" data-sentry-element="Typography" data-sentry-source-file="Rules.tsx">
        قوانین اقامتگاه
      </Typography>
      <Box className={styles['rules-main-container']} data-sentry-element="Box" data-sentry-source-file="Rules.tsx">
        <Box className={styles['right-rules-container']} data-sentry-element="Box" data-sentry-source-file="Rules.tsx">
          <Box onClick={() => drawerOpen('CANCEL')} data-sentry-element="Box" data-sentry-source-file="Rules.tsx">
            <CancellationRulesCard isMidterm={isMidTerm} cancellationRule={cancellationPlan} data-sentry-element="CancellationRulesCard" data-sentry-source-file="Rules.tsx" />
          </Box>
          {!isMidTerm && <UnConditionalTransfer productState={props} />}
        </Box>
        <Box className={styles['left-rules-container']} data-sentry-element="Box" data-sentry-source-file="Rules.tsx">
          <RulesContainer data={data} isMidTerm={isMidTerm} data-sentry-element="RulesContainer" data-sentry-source-file="Rules.tsx" />
          {isMobile ? <Drawer open={isDrawerOpen('CANCEL')} onClose={() => drawerClose()} fullHeight>
              <CancellationRulesContainer cancellationRule={cancellationPlans[data?.cancellation_plan]} handleClose={drawerClose} isMidterm={isMidTerm} />
            </Drawer> : <Modal open={isDrawerOpen('CANCEL')} onClose={() => drawerClose()} maxWidth={'550px'}>
              <CancellationRulesContainer cancellationRule={cancellationPlans[data?.cancellation_plan]} handleClose={drawerClose} isMidterm={isMidTerm} />
            </Modal>}
        </Box>
      </Box>
      <Divider data-sentry-element="Divider" data-sentry-source-file="Rules.tsx" />
    </Box>;
};
export default Rules;